import { Alert } from '@mui/material'
import React from 'react'

export const InvertedPassCriteriaNotification = () => {
  return (
    <Alert role="alert" severity="info">
      This test will pass when health checks are triggered. This was configured
      in your Scenario.
    </Alert>
  )
}
